<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<button #focusableEleTop class="focusable-element"></button>
<div class="row" *ngIf="hasError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages">
                    <button [innerHtml]="error"></button>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="IsErrorMesssage">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of errorMessage"><button>{{error}}</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="EnrollmentMethodError || SOAError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngIf="EnrollmentMethodError">
                    <button>
                        Please select a Enrollment Method.
                    </button>
                </li>
                <li *ngIf="SOAError">
                    <button>
                        Please select a Scope of Appointment.
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'Agent ID for this enrollment:'"
                                [text]="agentUserName"
                                (onValueChange)="dataEntryStep1.AgentName = $event"
                                [validators]="[notBlankValidator]"
                                [disabled]="isValidAgent">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div *ngIf="!isValidAgent">
            <button class="button primary" (click)="onContinue()">Continue</button>
        </div>
        <div *ngIf="isValidAgent">
            <button class="button primary" (click)="onChangeAgentId()">Change Agent ID</button>
        </div>
    </div>
</div>
<div *ngIf="isValidAgent">
    <div *ngIf="showMLPAP">
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Type:'"
                                               [options]="optionrbConactType"
                                               [selectedValue]="selFaxContactType"
                                               (onValueChange)="dataEntryStep1.DataSource = $event"
                                               [radioGroupName]="'ContactType'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <!--<ValidatedDateTextField [label]="'Date of Receipt:'"
                                            id="dateofReceipt "
                                            [date]="dataEntryStep1.DateofReceipt"
                                            (onDateChange)="dataEntryStep1.DateofReceipt = $event"
                                            [validators]="[validatedDate,notBlankValidator]">
                    </ValidatedDateTextField>-->
                    <label>Date of Receipt:</label>
                    <JQDatePicker [selectedDate]="dataEntryStep1.DateofReceipt"
                                  (elementClicked)="dataEntryStep1.DateofReceipt = $event">
                    </JQDatePicker>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!showMLPAP">
        <div class="row" style="clear:none">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Enrollment Method:'"
                                               [options]="optionrbEnrollmentMethod"
                                               [selectedValue]="selEnrollmentMethod"
                                               (onValueChange)="dataEntryStep1.DataSource = $event"
                                               [radioGroupName]="'EnrollmentMethod'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>

        <div class="row" style="clear:none">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Scope of Appointment:'"
                                               [options]="optionrbScope"
                                               [selectedValue]="dataEntryStep1.SOA"
                                               (onValueChange)="dataEntryStep1.SOA = $event"
                                               [radioGroupName]="'ScopeofAppointment'">
                    </ValidatedRadioButtonGroup>
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Submit</button>
        </div>
    </div>
</div>
